<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<style>
/* Reset completo para layout dashboard */
*, *::before, *::after {
  box-sizing: border-box;
}

/*
 * Layout raíz.
 * El dashboard gestiona su propio scroll interno vía `.wrapper`
 * (position: fixed + overflow-y: auto), por lo que el documento puede
 * hacer scroll normal sin afectarlo. Esto es lo que permite que las
 * páginas públicas (landing, acerca, contacto…) sean navegables.
 */
html, body {
  margin: 0;
  padding: 0;
  /*
   * `height: auto` es clave: semantic.min.css declara `body, html { height: 100% }`
   * y style.css declara `body { overflow-y: scroll }`. Con height fija el body se
   * convierte en contenedor de scroll propio (1000px) y el documento nunca
   * scrollea, dejando las páginas públicas sin navegación vertical.
   */
  height: auto;
  min-height: 100%;
  width: 100%;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
}
</style>
